module.exports = __webpack_public_path__ + "img/serch.e5ae4c5b.png";